import styled from 'styled-components'
import { Skeleton } from '~/components/shared'
import { VerticalStyledScrollBar } from '~/styles'

export const Container = styled.div.attrs(props => ({
  scrollbarBackground: props.theme.colors.colorf3f5f9
}))`
  position: relative;
  width: 100%;
  flex: 1;
  overflow: auto;
  padding-top: 1rem;
  ${VerticalStyledScrollBar}

  .loader-wrapper {
    display: block;
    padding: 0 15px;
  }

  ul {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
`

export const MenuSidebarLoader = styled(Skeleton).attrs(({ count, theme }) => ({
  count: count ?? 5,
  containerClassName: 'loader-wrapper',
  baseColor: theme.colors.colore6ebf1
}))`
  margin-top: 10px;
  margin-bottom: 15px;
  height: 20px;
`
